import { render, staticRenderFns } from "./AprovarNovosUsuarios.vue?vue&type=template&id=9d14cb96"
import script from "./AprovarNovosUsuarios.vue?vue&type=script&lang=ts"
export * from "./AprovarNovosUsuarios.vue?vue&type=script&lang=ts"
import style0 from "./AprovarNovosUsuarios.vue?vue&type=style&index=0&id=9d14cb96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports